import React from 'react'
import { Route, Routes } from 'react-router-dom'
// pages
import HomePage from '../Components/HomePage/HomePage'
import BestWeightLossComp from '../Components/Companies/Companies'
import EmetyaHome from '../Components/EmetyaHome/EmetyaHome'
import Alf from '../Components/Alf/Alf'
// Tools
import SiteMap from '../Tools/SiteMap/SiteMap'
import NotFound from '../Tools/NotFound/NotFound'
import PrivacyPolicy from '../Components/PrivacyPolicy/PrivacyPolicy'
import TermOfUse from '../Components/TermOfUse/TermOfUse'


export default function Main({ BestWeightLoss, CitiesData}) {

    return (
        <div>
            <Routes>
                {/* Pages */}
                <Route path="/" element={<EmetyaHome />} />
                <Route path="/glp1" element={<BestWeightLossComp BestWeightLoss={BestWeightLoss}  CitiesData={CitiesData}/>} />
                <Route path="/alf" element={<Alf />} />
                <Route path="/edit" element={<HomePage BestWeightLoss={BestWeightLoss}  />} />

                <Route path="/health/best-weight-loss" element={<BestWeightLossComp BestWeightLoss={BestWeightLoss} />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-use" element={<TermOfUse />} />

                {/* SiteMap */}
                {["/sitemaps", "/sitemap", "/widgets"].map((path, index) =>
                    <Route path={path} key={index} element={<SiteMap  />} />
                )}
                <Route path="*" element={<NotFound />} />
                <Route path="/sitemap/:id" element={<SiteMap />} />

            </Routes>
        </div>
    )
}
